import { inject, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

import { BalloonContentType, BalloonContentLayoutType, PlacemarkType } from '../types';

@Injectable({
  providedIn: 'root',
})
export class PlacemarksService {
  private readonly router = inject(Router);
  private readonly zone = inject(NgZone);

  getPlacemarks(balloonContent: BalloonContentType): PlacemarkType {
    const linkId = 'product-link';
    const urlAttribute = 'data-url';
    const { latitude, longitude } = balloonContent.geometry;

    const productLinkElement = `<font size=3><b><a style="color: #526ed3;" ${urlAttribute}="${balloonContent.link}" id="${linkId}">${balloonContent.name}</a></b></font>`;
    const descriptionShortElement = balloonContent.description ? `<div>${balloonContent.description}</div>` : '';
    const addressElement = `<div style="color: #4a5e72;">${balloonContent.address}</div>`;
    const routeLinkElement = `<a style="color: #526ed3;" href="https://yandex.ru/maps/?rtext=~${latitude},${longitude}&mode=routes" target="_blank">Проложить маршрут</a>`;

    const balloonContentLayout: BalloonContentLayoutType = {
      template:
        '<div class=ballon_header>{{ properties.balloonContentHeader|raw }}</div>' +
        '<div class=ballon_body>{{ properties.balloonContentBody|raw }}</div>' +
        '<div class=ballon_footer>{{ properties.balloonContentFooter|raw }}</div>',
      overrides: {
        build: function () {
          const link = document.getElementById(linkId);
          link?.addEventListener('click', this.route.bind(this));
        },
        clear: function () {
          const link = document.getElementById(linkId);
          link?.removeEventListener('click', this.route?.bind(this));
        },
        route: () => {
          this.zone.run(() => {
            const link = document.getElementById(linkId);
            const url = link?.attributes.getNamedItem(urlAttribute)?.value;

            if (url) {
              this.router.navigateByUrl(url);
            }
          });
        },
      },
    };

    return <PlacemarkType>{
      geometry: balloonContent.geometry,
      properties: {
        balloonContentHeader: productLinkElement,
        balloonContentBody: descriptionShortElement + addressElement,
        balloonContentFooter: routeLinkElement,
        clusterCaption: `<strong>${balloonContent.name}</strong>`,
        hintContent: `<strong>${balloonContent.address}</strong>`,
      },
      options: {
        preset: 'islands#blueDotIcon',
        balloonAutoPan: false,
        balloonPanelMaxMapArea: 0, // Если не указывать эту опцию, на картах маленького размера откроется балун-панель.
      },
      balloonContentLayout,
    };
  }
}
